<template>
  <div>
    <SmartCard class="p-2 m-2">
      <SmartRow
        class="form flex sub-form justify-between flex-nowrap flex-row p-1"
      >
        <div class="w-full">
          <div class="smart-label text-left">
            <span>Pessoa</span>
          </div>
          <v-radio-group
            class="m-0"
            v-model="value[index].pessoa"
            :mandatory="false"
            :id="'pessoa_' + index"
            :name="'pessoa_' + index"
            row
          >
            <v-radio label="Física" value="fisica" />
            <v-radio label="Jurídica" value="juridica" />
          </v-radio-group>
        </div>
        <div class="flex justify-end navigator" v-show="index != 0">
          <SmartIcon
            @click="$emit('remove', index)"
            class="p-1-2"
            name="trash"
            :size="3"
          />
        </div>
      </SmartRow>
      <!-- Pessoa fisica -->
      <SmartTitle
        heading="2"
        weight="medium"
        v-show="value[index].pessoa === 'fisica'"
        >Dados Pessoa Física</SmartTitle
      >
      <SmartRow
        class="form flex sub-form justify-between flex-nowrap flex-row p-1"
        v-show="value[index].pessoa === 'fisica'"
      >
        <div class="w-full">
          <SmartInput
            label="Nome"
            placeholder="Informe o nome do dependente"
            :id="'name_' + index"
            :name="'name_' + index"
            v-model="value[index].name"
            v-validate="pfValidate('required')"
            :mask="'N'.repeat(100)"
            :error="errors.first('name_' + index)"
          />
        </div>
        <div class="w-full">
          <SmartInput
            label="CPF"
            placeholder="Informe o cpf do cliente"
            :id="'cpf_' + index"
            :name="'cpf_' + index"
            v-model="value[index].cpf"
            v-validate="pfValidate('required|cpf')"
            :mask="'###.###.###-##'"
            :error="errors.first('cpf_' + index)"
          />
        </div>
      </SmartRow>
      <SmartRow
        class="form flex sub-form justify-between flex-nowrap flex-row p-1"
        v-show="value[index].pessoa === 'fisica'"
      >
        <div class="w-full">
          <SmartInput
            label="Data Nascimento"
            placeholder="dd/mm/aaaa"
            :id="'birthDate_' + index"
            :name="'birthDate_' + index"
            type="date-picker"
            v-model="value[index].birthDate"
            v-validate="pfValidate('required|lessToDay|olderThan16')"
            :error="errors.first('birthDate_' + index)"
          />
        </div>
        <div class="w-full">
          <SmartInput
            label="Identidade"
            placeholder="Informe a identidade do cliente"
            :id="'identity_' + index"
            :name="'identity_' + index"
            v-model="value[index].identity"
            v-validate="pfValidate('required')"
            :error="errors.first('identity_' + index)"
          />
        </div>
      </SmartRow>
      <SmartRow
        class="form flex sub-form justify-between flex-nowrap flex-row p-1"
        v-show="value[index].pessoa === 'fisica'"
      >
        <div class="w-full">
          <div class="flex justify-between">
            <SmartInput
              label="Órgão Expedidor"
              placeholder="Ex: SSP"
              :id="'shippingAgent_' + index"
              :name="'shippingAgent_' + index"
              v-model="value[index].shippingAgent"
              v-validate="pfValidate('required')"
              :error="errors.first('shippingAgent_' + index)"
            />
            <SmartInput
              label="Data de Emissão"
              placeholder="dd/mm/aaaa"
              :id="'issueDate_' + index"
              :name="'issueDate_' + index"
              type="date-picker"
              v-model="value[index].issueDate"
              v-validate="validateDate(pfValidate('required|lessToDay'))"
              :error="errors.first('issueDate_' + index)"
            />
          </div>
        </div>
        <div class="w-full">
          <SmartSelect
            label="UF"
            itemText="name"
            itemValue="UF"
            :items="states"
            v-model="value[index].uf"
            :name="'uf_' + index"
            :id="'uf_' + index"
            :error="errors.first('uf_' + index)"
            v-validate="pfValidate('required')"
            placeholder="Informe o estado"
          />
        </div>
      </SmartRow>
      <!-- Pessoa juridica -->
      <SmartTitle
        heading="2"
        weight="medium"
        v-show="value[index].pessoa === 'juridica'"
        >Dados Pessoa Jurídica</SmartTitle
      >
      <SmartRow
        class="form flex sub-form justify-between flex-nowrap flex-row p-1"
        v-show="value[index].pessoa === 'juridica'"
      >
        <div class="w-full">
          <SmartInput
            label="Razão Social"
            placeholder="Informe a razão social do cliente"
            :id="'corporateName_' + index"
            :name="'corporateName_' + index"
            v-model="value[index].corporateName"
            v-validate="pjValidate('required')"
            :error="errors.first('corporateName_' + index)"
          />
        </div>
        <div class="w-full">
          <SmartInput
            label="CNPJ"
            placeholder="Informe o CNPJ do cliente"
            :id="'cnpj_' + index"
            :name="'cnpj_' + index"
            v-model="value[index].cnpj"
            v-validate="pjValidate('required|cnpj')"
            mask="##.###.###/####-##"
            :error="errors.first('cnpj_' + index)"
          />
        </div>
      </SmartRow>

      <SmartTitle
        heading="2"
        weight="medium"
        v-show="value[index].pessoa === 'juridica'"
        >Representante Legal</SmartTitle
      >
      <SmartRow
        class="form flex sub-form justify-between flex-nowrap flex-row p-1"
        v-show="value[index].pessoa === 'juridica'"
      >
        <div class="w-full">
          <v-radio-group
            class="m-0"
            v-model="value[index].hasRepresentative"
            :mandatory="false"
            :id="'representative_' + index"
            :name="'representative_' + index"
            row
          >
            <v-radio label="Sim" :value="true" />
            <v-radio label="Não" :value="false" />
          </v-radio-group>
        </div>
        <div class="w-full dependent-procuration">
          <SmartInput
            v-show="value[index].hasRepresentative"
            label="Representante legal"
            placeholder="Informe o nome do Representante legal"
            :id="'representativeName_' + index"
            :name="'representativeName_' + index"
            v-model="value[index].representative"
            v-validate="
              pjValidate(value[index].hasRepresentative ? 'required' : '')
            "
            :error="errors.first('representativeName_' + index)"
            :mask="'N'.repeat(100)"
          />
        </div>
      </SmartRow>

      <SmartTitle heading="2" weight="medium">Acesso Dependente</SmartTitle>
      <SmartRow
        class="form flex sub-form justify-between flex-nowrap flex-row p-1"
      >
        <div class="w-full">
          <SmartInput
            label="Nº Tel (GSM) Dependente"
            placeholder="Informe o Nº Tel (GSM) Dependente"
            :id="'code_' + index"
            :name="'code_' + index"
            v-model="value[index].code"
            :mask="['(##) ####-####', ' (##) #####-####']"
            v-validate="'required|celPhone'"
            :error="errors.first('code_' + index)"
          />
        </div>
        <div class="w-full">
          <SmartInput
            label="Nº Tel (GSM) Titular"
            :id="'titularPhone_' + index"
            :mask="['(##) ####-####', ' (##) #####-####']"
            placeholder="Informe o Nº Tel (GSM) Titular"
            v-model="value[index].titularPhone"
            :name="'titularPhone_' + index"
            v-validate="'required|celPhone'"
            :disabled="!justDependent"
            :error="errors.first('titularPhone_' + index)"
          />
        </div>
      </SmartRow>
      <SmartRow
        class="form flex sub-form justify-between flex-nowrap flex-row p-1"
      >
        <div class="w-full">
          <SmartSelect
            v-if="justDependent"
            label="Plano Contratado"
            itemText="name"
            itemValue="plan"
            :items="plans"
            v-model="value[index].plan"
            :name="'plan_' + index"
            :id="'plan_' + index"
            :error="errors.first('plan_' + index)"
            v-validate="'required'"
            @change="loadPlanInfo"
            placeholder="Informe o Plano Contratado"
            :disabled="!justDependent"
          />
        </div>
        <div class="w-full">
          <SmartInput
            label="Nº do Protocolo"
            :id="'protocol_' + index"
            v-model="value[index].protocol"
            :name="'protocol_' + index"
            placeholder="Informe o Nº do Protocolo"
            v-validate="'required'"
            :error="errors.first('protocol_' + index)"
            :mask="'#'.repeat(50)"
          />
        </div>
      </SmartRow>

      <PortabilityElement v-model="value[index]" :index="index" />
      <SmartRow class="pl-3" style="page-break-before: always">
        <div class="w-full">
          <div class="smart-label text-left">
            <p class="high-p">Cliente com Deficiência ou Analfabeto</p>
          </div>
          <SmartCheckbox
            label="Cliente com Deficiência ou Analfabeto"
            class="pb-3"
            v-model="value[index].illiterate"
            :id="'illiterate_' + index"
            :name="'illiterate_' + index"
          />
        </div>
      </SmartRow>
    </SmartCard>

    <SmartTitle heading="3" weight="medium">&nbsp;</SmartTitle>
    <SmartCard class="p-2 m-2 mt-0">
      <SmartRow class="pl-3">
        <div class="w-full">
          <div class="smart-label text-left">
            <p class="high-p">
              Você, CLIENTE, gostaria de ficar por dentro de novos produtos,
              serviços e promoções? A TIM pode te oferecer essa facilidade
              gratuitamente, através de mensagens de texto e/ou multimídia
            </p>
          </div>
          <v-radio-group
            class="mt-2 high-p"
            v-model="value[index].messageTerm"
            :mandatory="false"
            :id="'messageTerm_' + index"
            :name="'messageTerm_' + index"
            row
          >
            <v-radio
              label="Sim, concordo com o recebimento das mensagens citadas no item anterior para o (s) telefone (s) acima informado(s)"
              :value="true"
            />
            <v-radio
              class="mt-2"
              label="Não, não concordo com o recebimento das mensagens citadas no item anterior para o(s) telefone(s) acima informado(s)"
              :value="false"
            />
          </v-radio-group>
        </div>
      </SmartRow>

      <SmartRow
        class="pt-3 pl-3"
        v-if="
          (term.tipoVenda === 'venda ' && term.tipoServico === 'smp') ||
          (term.tipoVenda === 'venda' && term.tipoServico === 'convergencia') ||
          (term.tipoVenda === 'venda' &&
            term.tipoServico !== 'scm' &&
            term.tipoServico !== 'stfc' &&
            (term.plan != 'live' || term.plan != 'fixo')) ||
          (term.tipoVenda === 'posVenda' &&
            term.posVenda.isTransferencia &&
            term.tipoServico === 'smp' &&
            (!term.isPlanLive || !term.isPlanFixo)) ||
          (term.tipoVenda === 'posVenda' &&
            (term.posVenda.isMudancaPlano || term.posVenda.isTrocaAparelho) &&
            term.tipoServico !== 'scm' &&
            term.tipoServico !== 'stfc' &&
            (!term.isPlanLive || !term.isPlanFixo))
        "
      >
        <div class="w-full">
          <div class="smart-label text-left">
            <p class="high-p">
              O cliente está ciente do mapa de cobertura e que a TIM oferece
              cobertura na sua região?
            </p>
          </div>
          <v-radio-group
            class="mt-2 high-p"
            v-model="value[index].messageTAC"
            :mandatory="false"
            col
          >
            <v-radio label="Sim" :value="true" />
            <v-radio class="mt-2" label="Não" :value="false" />
          </v-radio-group>
        </div>
      </SmartRow>

      <SmartRow
        class="pt-3 pl-3"
        v-if="
          (term.tipoVenda === 'posVenda' &&
            term.tipoServico === 'smp' &&
            term.plan !== 'wttx') ||
          (term.tipoServico === 'smp' && term.plan !== 'wttx') ||
          term.tipoServico === 'convergencia'
        "
      >
        <div class="w-full">
          <div class="smart-label text-left">
            <p class="high-p">
              Em caso de venda realizada pelo APP TIM VENDAS, o cliente aceitou
              ter sua foto de rosto utilizada para cadastro?
            </p>
          </div>
          <v-radio-group
            class="mt-2 high-p"
            v-model="value[index].messageBiometry"
            :mandatory="false"
            col
          >
            <v-radio label="Sim" :value="true" />
            <v-radio class="mt-2" label="Não" :value="false" />
          </v-radio-group>
        </div>
      </SmartRow>

      <SmartRow class="pt-3 pl-3">
        <div class="w-full" v-show="payment.type !== 'card'">
          <div class="smart-label text-left">Você, CLIENTE, autoriza</div>
          <div class="flex flex-row mt-1">
            <v-radio-group
              class="m-0"
              v-model="value[index].invoiceType"
              :mandatory="false"
            >
              <v-radio
                label="Recebimento da fatura através da conta digital"
                value="online"
              />
              <v-radio
                label="Recebimento da fatura impressa através dos correios"
                value="offline"
              />
            </v-radio-group>
          </div>
        </div>
      </SmartRow>
    </SmartCard>

    <br />
    <br />
    <br />
    <br />
    <br />
    <SmartTitle heading="3" weight="medium">&nbsp;</SmartTitle>
    <SmartCard class="p-2 m-2 mt-0 smart-card-navgation">
      <SmartRow
        class="form flex sub-form justify-between flex-nowrap flex-row p-3"
        v-show="value.length === index + 1"
      >
        <div class="w-full">
          <SmartButton
            v-show="canAdd"
            class="mx-1"
            box
            @click="$emit('addNew')"
            :id="'addDependent_' + index"
            >Adicionar Mais Dependentes</SmartButton
          >
        </div>

        <div class="flex justify-end navigator">
          <SmartButton
            class="mx-1"
            id="btn_cancel"
            text
            @click="$emit('cancel')"
            >Cancelar</SmartButton
          >
          <SmartButton
            class="mx-1"
            id="btn_back"
            quaternary
            @click="$emit('back')"
            >Voltar</SmartButton
          >
          <SmartButton
            class="mx-1"
            :id="'btn_next_' + index"
            @click="$emit('next')"
            >Avançar</SmartButton
          >
        </div>
      </SmartRow>
    </SmartCard>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import states from "constants/states";
import plans from "constants/plans";

export default {
  props: {
    index: {
      type: Number,
      default: 0,
    },
    payment: {
      type: Object,
      default: [],
    },
    canAdd: {
      type: Boolean,
      default: true,
    },
    justDependent: {
      type: Boolean,
      default: false,
    },
    value: {}, // eslint-disable-line
  },
  // mounted: function() {
  //   this.$root.$on("atualizarplanos", d => {
  //     this.plans = d;
  //   });
  // },
  data() {
    return {
      states,
      dependent: {},
      plans,
    };
  },
  components: {
    PortabilityElement: () => import("./PortabilityElement.vue"),
  },
  computed: {
    ...mapGetters({
      term: "term/term",
      cities: "address/cities",
      getCityById: "address/getCityById",
    }),
  },
  methods: {
    ...mapActions({
      setCustomerAttr: "term/setCustomerAttr",
      fetchCities: "address/fetchCities",
      fetchAddressByCep: "address/fetchAddressByCep",
    }),
    pfValidate(value) {
      return this.value[this.index].pessoa === "fisica" ? value : "";
    },
    pjValidate(value) {
      return this.value[this.index].pessoa === "juridica" ? value : "";
    },
    procurationValidate(value) {
      return this.value[this.index].hasProcuration ? value : "";
    },
    reloadCities(value) {
      this.fetchCities(value);
    },
    reloadAddress() {
      this.fetchAddressByCep(this.zipCode.match(/\d/g).join("")).then(
        (data) => {
          this.neighborhood = data.bairro;
          this.address = data.logradouro;
          this.state = data.estado;
          this.fetchCities(data.estado).then(() => {
            const cityId = parseInt(data.cidade_info.codigo_ibge, 10);
            this.city = cityId;
          });
        }
      );
    },
    getPlans() {
      return this.plans;
    },
    loadPlanInfo(selected) {
      const plan = this.plans.find((e) => e.name === selected);
      this.value[this.index].planValue = plan.planValue;
      // this.value[this.index].dataPackage = plan.dataPackage;
      // this.value[this.index].promotionalValue = plan.promotionalValue;
    },
    isValid() {
      this.$validator.validateAll();
      return Object.keys(this.fields).every((field) =>
        this.focusOnError(field)
      );
    },
    focusOnError(field) {
      const isValid = this.fields[field].valid;
      if (!isValid) {
        document.getElementsByName(field)[0].focus();
      }
      return isValid;
    },
    validateDate(value) {
      return `${value}|isBefore:${this.value[this.index].birthDate}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.form {
  .smart-input__wrapper {
    margin-bottom: $spacing-margin-xsmall;
  }
  .smart-select__wrapper {
    margin-bottom: $spacing-margin-xsmall;
  }
}
.dependent-procuration {
  margin-top: -38px;
}
</style>
